import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/almoxarifado`

    const headers = { responseType: "arraybuffer" }

    return {
       relatorioConsumoFinanceiro(queryParms) {

            return repository.get(`${baseUrl}/relatorio-consumo-financeiro?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEntrada(queryParms) {
            return repository.post(`${baseUrl}/relatorio-entrada`, queryParms, headers)
        },
        baixa(id) {

            return repository.get(`${baseUrl}/baixa/${id}`, headers)
        },
        inventario(queryParms) {

            return repository.get(`${baseUrl}/inventario?${urlUtil.serialize(queryParms)}`, headers)
        },
        requisicao(id, sort) {

            return repository.get(`${baseUrl}/requisicao/${id}?sort=${sort}`, headers)
        },
        requisicaoSeparacaoMaterial(id, sort) {

            return repository.get(`${baseUrl}/requisicao-separacao-material/${id}?sort=${sort}`, headers)
        },
        saida(id) {

            return repository.get(`${baseUrl}/saida/${id}`, headers)
        },
        transferencia(id) {

            return repository.get(`${baseUrl}/transferencia/${id}`, headers)
        },
        balancete(queryParms) {

            return repository.get(`${baseUrl}/balancete?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstornoEntrada(queryParms) {

            return repository.get(`${baseUrl}/relatorio-estorno-entrada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstornoSaida(queryParms) {

            return repository.get(`${baseUrl}/relatorio-estorno-saida?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioValidadeMaterial(queryParms) {

            return repository.get(`${baseUrl}/relatorio-validade-material?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioSaida(queryParms) {

            return repository.get(`${baseUrl}/relatorio-saida?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPosicaoEstoque(queryParms) {

            return repository.get(`${baseUrl}/relatorio-posicao-estoque?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioRequisicao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-requisicao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioConsumoMedioMensal(queryParms) {

            return repository.get(`${baseUrl}/relatorio-consumo-medio-mensal?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioMovimentacaoGeral(queryParms) {

            return repository.get(`${baseUrl}/relatorio-movimentacao-geral?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
